<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Simulação da Antecipação</b>
            </h3>
          </div>
          <div class="box-body">
            <table
              aria-describedby="example1_info"
              role="grid"
              id="example1"
              class="table table-bordered table-striped"
              style="margin-top: 30px;"
            >
              <thead>
                <tr>
                  <th
                    colspan="7"
                    style="text-align:center; text-transform:uppercase;"
                  >Relação de boletos em aberto para antecipação</th>
                </tr>
                <tr>
                  <th style="width: 10%">Data</th>
                  <th style="width: 15%">Garantia</th>
                  <th style="width: 30%">Cliente</th>
                  <th style="width: 10%">Vencimento</th>
                  <th style="width: 15%">Valor</th>
                  <th style="width: 10%">Prorata</th>
                  <th style="width: 10%">Taxa</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="bol in boletos.boletos" :key="bol.id">
                  <td>{{ bol.created_at | dataFormatada }}</td>
                  <td>{{bol.id +'-'+ bol.digito}}</td>
                  <td style="text-transform: uppercase;">{{bol.garantia.pessoa.nome_razao}}</td>
                  <td>{{bol.vencimento | dataFormatada}}</td>
                  <td>{{ bol.valor_garantido | numberFormat(2, ',', '.') }}</td>
                  <td>
                    {{ bol.prorata | numberFormat(2, ',', '.') }}
                    <small>({{bol.qtd_dias}} dias)</small>
                  </td>
                  <td>{{ bol.antecipacao | numberFormat(2, ',', '.') }}</td>
                </tr>
                <tr>
                  <td colspan="4" style="text-align: right;">
                    <strong>Subtotal</strong>
                  </td>
                  <td>
                    <strong>{{ boletos.totais.total_boletos | numberFormat(2, ',', '.') }}</strong>
                  </td>
                  <td>
                    <strong>{{ boletos.totais.total_prorata | numberFormat(2, ',', '.') }}</strong>
                  </td>
                  <td>
                    <strong>{{ boletos.totais.total_taxa_antecipacao | numberFormat(2, ',', '.') }}</strong>
                  </td>
                </tr>
              </tbody>
            </table>

            <table
              aria-describedby="example1_info"
              role="grid"
              id="example1"
              class="table table-bordered table-striped"
              style="margin-top: 30px;"
            >
              <thead>
                <tr>
                  <th colspan="7" style="text-align:center; text-transform:uppercase;">Resumo</th>
                </tr>
                <tr>
                  <th style="width: 12%">Data</th>
                  <th style="width: 13%">Qtd. de Boletos</th>
                  <th style="width: 13%">Total Boletos</th>
                  <th style="width: 13%">Prorata</th>
                  <th style="width: 13%">Taxa Antecipação</th>
									<th style="width: 13%">Taxa Básica</th>
                  <th style="width: 13%">Total da Antecipação</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ boletos.totais.data_simulacao | dataHoraFormatada }}</td>
                  <td>{{ boletos.totais.qtd_boletos }}</td>
                  <td>{{ boletos.totais.total_boletos | numberFormat(2, ',', '.') }}</td>
                  <td>{{ boletos.totais.total_prorata | numberFormat(2, ',', '.') }}</td>
                  <td>{{ boletos.totais.total_taxa_antecipacao | numberFormat(2, ',', '.') }}</td>
									<td>{{ boletos.totais.taxa_basica | numberFormat(2, ',', '.') }}</td>
                  <td>
                    <strong>{{ boletos.totais.total_antecipacao | numberFormat(2, ',', '.') }}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="box-footer text-center" style="padding: 30px;">
            <router-link tag="button" to="/operacao/antecipacoes" class="btn btn-default">Cancelar</router-link>
            <button class="btn btn-warning" @click="salvar()">
              Enviar Solicitação
              <small>(Sujeito a análise)</small>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
import { mask } from "vue-the-mask";
import vSelect from "vue-select";
import { Money } from "v-money";

export default {
  directives: { mask },
  data() {
    return {
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },
      taxa: {
        decimal: ".",
        thousands: "",
        prefix: "",
        precision: 2,
        masked: false
      },
      dados: {
        data_simulacao: null
      },
      boletos: []
    };
  },
  mounted() {
    this.simular();
  },

  methods: {
    simular() {
      let config = this.$store.getters.getHeaderAuth;
      config.params = this.dados;
      axios
        .get(
          `${this.$store.state.serverURI}/api/relatorio/simulaAntecipacao`,
          config
        )
        .then(response => {
          this.boletos = response.data;
          this.dados.data_simulacao = response.data.totais.data_simulacao;
        })
        .catch(error => {
          this.$store.commit("throwException", error);
        });
    },

    salvar() {
      axios
        .post(
          `${this.$store.state.serverURI}/api/relatorio/createAntecipacao`,
          this.dados,
          this.$store.getters.getHeaderAuth
        )
        .then(response => {
          this.$swal({
            type: response.data.status == 200 ? "success" : "error",
            title:
              response.data.status == 200
                ? "Tudo Certo!"
                : "Ops! Ocorreu um erro.",
            text: response.data.msg,
            showConfirmButton: false,
            timer: 1500
          });
          this.$router.push("/operacao/antecipacoes");
        })
        .catch(error => {
          this.$store.commit("SHOW_ALERT_ERROR");
          console.log(error);
        });
    }
  },
  watch: {},
  components: {
    vSelect,
    Money
  }
};
</script>
<style scoped>
input {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// form.vue?5849f126